import {useRef, useEffect} from "../../_snowpack/pkg/react.js";
const useDidMount = () => {
  const mountRef = useRef(false);
  useEffect(() => {
    mountRef.current = true;
  }, []);
  return mountRef.current;
};
export {useDidMount};
